{
  "DATE_PICKER": {
    "APPLY_BUTTON": "Confirmar",
    "CLEAR_BUTTON": "Limpar",
    "DATE_RANGE_INPUT": {
      "START": "Data inicial",
      "END": "Data final"
    },
    "DATE_RANGE_OPTIONS": {
      "TITLE": "Intervalo de datas",
      "TODAY": "Hoje",
      "YESTERDAY": "Ontem",
      "LAST_7_DAYS": "Últimos 7 Dias",
      "LAST_30_DAYS": "Últimos 30 Dias",
      "LAST_3_MONTHS": "Últimos 3 meses",
      "LAST_6_MONTHS": "Últimos 6 meses",
      "LAST_YEAR": "Último ano",
      "CUSTOM_RANGE": "Intervalo de tempo personalizado"
    }
  }
}
